import { useState } from "react";
import AgentsAPI from "../../../api/AgentsAPI";

const useUpdateAgentPersonalDetails = () => {
	const [loading, setLoading] = useState(false);

	const updateAgentPersonalDetails = async (agentId, data) => {
		setLoading(true);

		try {
			const result = await AgentsAPI.updateAgentPersonalDetails(agentId, data);
			return { success: true, data: result };
		} catch (error) {
			console.error("Failed to update agent personal details:", error);
			return { success: false, error: error.message };
		} finally {
			setLoading(false);
		}
	};

	return {
		updateAgentPersonalDetails,
		loading,
	};
};

export default useUpdateAgentPersonalDetails;
